var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "page",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-attrs": _vm.tableAttrs,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: { click: _vm.handleSpecialSetting },
                      },
                      [_vm._v("特殊公告设置")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colTitle",
            fn: function ({ row }) {
              return [
                _c("LanguageInputEcho", { attrs: { obj: row.title || {} } }),
              ]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.getStatusTagType(row.status),
                      size: "small",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.getStatusText(row.status)) + " ")]
                ),
              ]
            },
          },
          {
            key: "colType",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm.getTypeText(row.type)))]
            },
          },
          {
            key: "colCreatedAt",
            fn: function ({ row }) {
              return [
                _vm._v(
                  _vm._s(row.created_at ? _vm.parseTime(row.created_at) : "--")
                ),
              ]
            },
          },
          {
            key: "colPublishAt",
            fn: function ({ row }) {
              return [
                _vm._v(
                  _vm._s(row.publish_at ? _vm.parseTime(row.publish_at) : "--")
                ),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                row.disable_at !== 0 && row.disable_at < new Date().getTime()
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          placement: "top",
                          content: "已过期，请修改停用时间后再启用",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini", disabled: "" },
                          },
                          [_vm._v("启用")]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleToggleStatus(row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(row.status === 1 ? "停用" : "启用") + " "
                        ),
                      ]
                    ),
                row.status === 2
                  ? _c(
                      "el-popconfirm",
                      {
                        attrs: {
                          title: "确定删除吗？",
                          "confirm-button-text": "确定",
                          "cancel-button-text": "取消",
                          type: "warning",
                        },
                        on: {
                          confirm: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "danger-button",
                            staticStyle: { "margin-left": "8px" },
                            attrs: {
                              slot: "reference",
                              type: "text",
                              size: "mini",
                            },
                            slot: "reference",
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("ManageSystemNoticeDialog", {
        attrs: {
          visible: _vm.noticeDialogVisible,
          "dialog-title": _vm.noticeDialogTitle,
          "form-data": _vm.currentNoticeForm,
        },
        on: {
          "update:visible": function ($event) {
            _vm.noticeDialogVisible = $event
          },
          success: _vm.handleDialogSuccess,
        },
      }),
      _c("SpecialNoticeSettingDialog", {
        attrs: { visible: _vm.specialDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.specialDialogVisible = $event
          },
          success: _vm.handleSpecialDialogSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }